import { render, staticRenderFns } from "./AgenciaContactos.vue?vue&type=template&id=06c899c2"
import script from "./AgenciaContactos.vue?vue&type=script&lang=js"
export * from "./AgenciaContactos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports